module.exports = __webpack_public_path__ + "static/img/cookies.1a371d1b.png";